import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { Theme } from '@core/enums/theme';
import { ThemeService } from '@core/services/theme.service';

@Component({
  selector: 'app-sidebar-theme-switch',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  template: `
    <div
      class="group flex cursor-pointer items-center gap-x-2"
      (click)="toggleTheme()">
      <span class="dark:text-dune-0">{{ name() }}</span>
      <div
        class="group-hover:text-greenish-500 text-neutral-1000 dark:text-neutral-0 mb-[1px] text-sm"
        [ngClass]="{ 'pb-0.5': currentTheme() === Theme.DARK }">
        <svg
          class="size-[18px]"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20">
          @if (currentTheme() === Theme.LIGHT) {
            <path
              d="M10 15a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0-11a1 1 0 0 0 1-1V1a1 1 0 0 0-2 0v2a1 1 0 0 0 1 1Zm0 12a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1ZM4.343 5.757a1 1 0 0 0 1.414-1.414L4.343 2.929a1 1 0 0 0-1.414 1.414l1.414 1.414Zm11.314 8.486a1 1 0 0 0-1.414 1.414l1.414 1.414a1 1 0 0 0 1.414-1.414l-1.414-1.414ZM4 10a1 1 0 0 0-1-1H1a1 1 0 0 0 0 2h2a1 1 0 0 0 1-1Zm15-1h-2a1 1 0 1 0 0 2h2a1 1 0 0 0 0-2ZM4.343 14.243l-1.414 1.414a1 1 0 1 0 1.414 1.414l1.414-1.414a1 1 0 0 0-1.414-1.414ZM14.95 6.05a1 1 0 0 0 .707-.293l1.414-1.414a1 1 0 1 0-1.414-1.414l-1.414 1.414a1 1 0 0 0 .707 1.707Z"></path>
          } @else {
            <path
              d="M17.8 13.75a1 1 0 0 0-.859-.5A7.488 7.488 0 0 1 10.52 2a1 1 0 0 0 0-.969A1.035 1.035 0 0 0 9.687.5h-.113a9.5 9.5 0 1 0 8.222 14.247 1 1 0 0 0 .004-.997Z"></path>
          }
        </svg>
      </div>
    </div>
  `,
})
export class SidebarThemeSwitchComponent {
  /** PROPERTIES **/
  /****/
  protected readonly currentTheme = this.themeService.theme;

  /** Localized label for the currently active theme. */
  protected readonly name = computed(() =>
    this.currentTheme() === Theme.DARK
      ? $localize`:@@sidebar.user-menu.theme.dark:Dark`
      : $localize`:@@sidebar.user-menu.theme.light:Light`
  );

  constructor(private readonly themeService: ThemeService) {}

  protected toggleTheme() {
    this.themeService.toggleTheme();
  }

  protected readonly Theme = Theme;
}
